import { useState, type FormEvent } from 'react';
import { ApiRequestError } from './api.js';
import { useAuth } from './auth.js';

/**
 * Giriş ekranı. İki kanalda da aynı — el terminalinde de masaüstünde de
 * bu ekran kullanılır, o yüzden core/ altında.
 */
export function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (busy) return;

    setError(null);
    setBusy(true);

    try {
      await login(username.trim(), password);
    } catch (err) {
      if (err instanceof ApiRequestError) {
        setError(
          err.status === 429
            ? 'Çok fazla deneme yapıldı. Bir dakika sonra tekrar deneyin.'
            : err.message,
        );
      } else {
        setError('Sunucuya ulaşılamadı. Bağlantınızı kontrol edin.');
      }
      setBusy(false);
    }
  }

  return (
    <div className="giris-sayfa">
      <form className="giris-kart" onSubmit={onSubmit}>
        <div className="giris-logo">
          <h1>KonyaXL</h1>
          <p>Barkod eşleştirme sistemi</p>
        </div>

        {error && <div className="hata-kutu">{error}</div>}

        <div className="alan">
          <label htmlFor="username">Kullanıcı adı</label>
          <input
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoCapitalize="none"
            autoCorrect="off"
            disabled={busy}
            required
            autoFocus
          />
        </div>

        <div className="alan">
          <label htmlFor="password">Şifre</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            disabled={busy}
            required
          />
        </div>

        <button className="btn-birincil" type="submit" disabled={busy}>
          {busy ? 'Giriş yapılıyor…' : 'Giriş'}
        </button>
      </form>
    </div>
  );
}
